import { render, staticRenderFns } from "./organizationalStructureList.vue?vue&type=template&id=74c8f2fa&scoped=true&"
import script from "./organizationalStructureList.vue?vue&type=script&lang=js&"
export * from "./organizationalStructureList.vue?vue&type=script&lang=js&"
import style0 from "./organizationalStructureList.vue?vue&type=style&index=0&id=74c8f2fa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c8f2fa",
  null
  
)

export default component.exports